import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import './Oprating_Areas.css'
import oprating1 from '../../assets/images/oprating areas/oprating1.png'
import oprating2 from '../../assets/images/oprating areas/oprating2.png'
import oprating3 from '../../assets/images/oprating areas/oprating3.png'
import oprating4 from '../../assets/images/oprating areas/oprating4.png'
import oprating5 from '../../assets/images/oprating areas/oprating5.png'
import oprating6 from '../../assets/images/oprating areas/oprating6.png'
import oprating7 from '../../assets/images/oprating areas/oprating7.png'
import oprating8 from '../../assets/images/oprating areas/oprating8.png'
import oprating9 from '../../assets/images/oprating areas/oprating9.png'
import oprating10 from '../../assets/images/oprating areas/oprating10.png'
import oprating11 from '../../assets/images/oprating areas/oprating11.png'
import oprating12 from '../../assets/images/oprating areas/oprating12.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const Oprating_Areas = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);
  return (
    <>
      <h1 className='oprating-main-heading pt-lg-5 pt-3' data-aos="zoom-in">We at Oreus Lifesciences operate with<br /> below specified department</h1>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Quality Control<label></label></h3>
              <p>Ensuring compliance with regulatory standards and guidelines</p>
              <p>Conducting rigorous testing and inspection of raw materials, intermediates, and finished products</p>
              <p>Maintaining high-quality laboratory facilities and equipment</p>
              <p>Implementing Good Laboratory Practices (GLP) and Good Manufacturing Practices (GMP)</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating1} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating2} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Quality Assurance<label></label></h3>
              <p>Developing and implementing quality policies and procedures</p>
              <p>Conducting audits and inspections to ensure compliance</p>
              <p> Monitoring and controlling quality-related documentation</p>
              <p>Collaborating with regulatory agencies to ensure compliance</p>

            </div>
          </div>

        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Pharmacovigilance<label></label></h3>
              <p>Monitoring and reporting adverse drug reactions</p>
              <p>Conducting risk-benefit assessments and signal detection</p>
              <p>Maintaining compliance with global regulatory requirements</p>
              <p>Ensuring patient safety through proactive risk management</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating3} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating4} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Medico Marketing<label></label></h3>
              <p>Developing and executing medical marketing strategies</p>
              <p>Providing scientific support for product promotion</p>
              <p>Collaborating with healthcare professionals and key opinion leaders</p>
              <p>Ensuring compliance with regulatory guidelines for promotional materials</p>

            </div>
          </div>

        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Strategic Training and Development<label></label></h3>
              <p>Designing and delivering training programs for employees</p>
              <p>Enhancing skills and knowledge in the pharmaceutical industry</p>
              <p>Fostering a culture of continuous learning and development</p>
              <p>Aligning training with business objectives and strategies</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating5} alt="" />
            </div>
          </div>
        </div>
      </div>

     {/* start Other Departments Section  */}

     <h1 className='oprating-main-heading pt-lg-5' data-aos="zoom-in">Other Departments</h1>
     <div className="container-fluid gx-0">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating6} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Research and Development<label></label></h3>
             <p>Discovering and developing innovative pharmaceutical products</p>
             <p>Conducting clinical trials and studies</p>
             <p>Collaborating with external partners and institutions</p>
             <p>Ensuring compliance with regulatory requirements</p>
            </div>
          </div>

        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Regulatory Affairs<label></label></h3>
              <p>Ensuring compliance with global regulatory requirements</p>
              <p>Preparing and submitting regulatory documents</p>
              <p>Maintaining knowledge of changing regulatory landscapes</p>
              <p>Collaborating with regulatory agencies</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating7} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6 gx-0">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating8} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Manufacturing<label></label></h3>
              <p>Producing high-quality pharmaceutical products</p>
              <p>Maintaining compliance with GMP and other regulations</p>
              <p>Optimising manufacturing processes and efficiency</p>
              <p>Ensuring supply chain reliability</p>

            </div>
          </div>

        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Supply Chain Management<label></label></h3>
              <p>Managing procurement, logistics, and distribution</p>
              <p>Ensuring timely delivery of raw materials and finished products</p>
              <p>Maintaining inventory control and management</p>
              <p>Collaborating with external partners and suppliers</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating9} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating10} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Clinical Research<label></label></h3>
              <p>Conducting clinical trials and studies</p>
              <p>Ensuring compliance with GCP and regulatory requirements</p>
              <p>Managing clinical data and trial management</p>
              <p>Collaborating with investigators and sites</p>

            </div>
          </div>

        </div>
      </div>

      <div className="container-fluid gx-0">
        <div className="row gx-0 change-column-direction">
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Medical Affairs<label></label></h3>
              <p>Providing scientific support for products</p>
              <p>Collaborating with healthcare professionals and key opinion leaders</p>
              <p>Developing and maintaining scientific documentation</p>
              <p>Ensuring compliance with regulatory guidelines</p>

            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating11} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid gx-0 mb-3">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-6">
            <div className="oprating-areas-img" data-aos="zoom-in">
              <img className='img-fluid' src={oprating12} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 ">
            <div className="content ps-lg-5" data-aos="zoom-in">
              <h3 className='oprating-areas-heading'><label></label>Business Development<label></label></h3>
              <p>Identifying and evaluating business opportunities</p>
              <p>Developing strategic partnerships and collaborations</p>
              <p>Conducting market research and analysis</p>
              <p>Driving business growth and expansion</p>

            </div>
          </div>

        </div>
      </div>

     {/* end Other Departments Section  */}

    </>
  )
}


export default Oprating_Areas
